<template>
  <!-- Loading Spinner -->
  <v-row v-if="pageLoading" class="mt-5" justify="center">
    <v-sheet color="grey" class="pa-3">
      <v-skeleton-loader
        class="mx-auto"
        width="300"
        max-width="300"
        type="card"
      ></v-skeleton-loader>
    </v-sheet>
  </v-row>
  <!-- Page Content -->
  <div v-else>
    <v-row class="mt-5 w-100" justify="center">
      <v-col cols="12">
        <p
            v-if="pageContent && pageContent.content"
            class="mt-5"
            v-html="pageContent.content"
        />
      </v-col>
    </v-row>
    <v-row class="mt-5 w-100" justify="center">
      <v-card width="100%">
        <v-card v-if="show === 'form'">
          <v-card-title class="justify-content-center bg-tfsc">
            <v-row :class="mobile ? 'text-center justify-content-center' : ''">
              <v-col :cols="mobile ? '12' : '6'">
                <span
                  :class="mobile ? 'text-h5 text-center' : 'text-h5 text-left'"
                  >{{
                    showMakeABooking
                      ? "Show Availability Calendar"
                      : "Make A Booking"
                  }}</span
                >
              </v-col>
              <v-col>
                <v-btn
                  :class="mobile ? 'text-center' : 'float-right'"
                  color="lightgrey"
                  @click="showMakeABooking = !showMakeABooking"
                  >{{
                    !showMakeABooking
                      ? "Show Availability Calendar"
                      : "Make A Booking"
                  }}<v-icon
                    :id="
                      showMakeABooking
                        ? 'Show Availability Calendar'
                        : 'Make A Booking'
                    "
                    style="cursor: pointer;"
                    class="ml-2"
                    >{{ !showMakeABooking ? "event" : "note_alt" }}</v-icon
                  ></v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text v-if="!showMakeABooking">
            <div class="container-fluid">
              <v-row class="mt-1">
                <v-col :cols="mobile ? '12' : '6'">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    class="mt-3"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormattedMomentjs"
                        label="Select Date* "
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="en-gb"
                      no-title
                      v-model="date"
                      year-icon="mdi-calendar-blank"
                      prev-icon="mdi-skip-previous"
                      next-icon="mdi-skip-next"
                      :min="formatToday"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label>Start Time* </label>
                  <vue-timepicker
                    hide-disabled-hours
                    placeholder="Start Time"
                    :hour-range="hourRange"
                    v-model="startTime"
                    :minute-interval="30"
                  ></vue-timepicker>
                </v-col>
                <v-col cols="6">
                  <label>End Time* </label>
                  <vue-timepicker
                    hide-disabled-hours
                    placeholder="End Time"
                    :hour-range="hourRangeEnd"
                    v-model="endTime"
                    :minute-interval="30"
                  ></vue-timepicker>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="sport"
                    @change="updateSport"
                    :items="sportOptions"
                    label="Select a Sport*"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <small class="mb-0">*indicates required field</small>
              <small class="mb-0"
                >Please note you can't make a booking online within the next 2
                hours.
              </small>
              <small>Must be a minimum of 60 minutes</small>
            </div>
          </v-card-text>
          <div class="container-fluid" v-else>
            <v-row
              :class="
                !mobile ? 'justify-content-end' : 'justify-content-center'
              "
            >
              <v-col :cols="mobile ? '12' : '3'" class="pb-0 mb-0">
                <v-form-group
                  class="mb-0"
                  label="Select a Facility"
                  label-for="facility"
                >
                  <v-select
                    v-model="facility"
                    @change="getSlots(facility)"
                    :items="facilityOptions"
                  />
                </v-form-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <SlotsCalendar
                  key="3"
                  :facilities="facilities"
                  :slots="slots"
                  :mobile="mobile"
                  :makeABooking="false"
                  :searchDate="''"
                  @setShowMakeBooking="setShowMakeBooking($event)"
                  @slotClicked="slotClicked($event)"
                />
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              v-if="!showMakeABooking"
              color="blue darken-1"
              text
              @click="checkAvailability"
            >
              Check
            </v-btn>
          </v-card-actions>
          <v-alert
            v-if="validateDates"
            class="text-center m-1 mb-0"
            color="red"
            dark
            :icon="false"
            type="error"
            dense
            outlined
            >Please Select Valid Dates (Booking must be at least 60
            minutes)</v-alert
          >
          <v-alert
            v-if="validateForm"
            class="text-center m-1 mb-0"
            color="red"
            dark
            :icon="false"
            type="error"
            dense
            outlined
            >Please Complete All Required Fields</v-alert
          >
        </v-card>
        <v-card v-if="show === 'fac-list'">
          <v-card-title class="justify-content-center bg-tfsc">
            <v-row>
              <v-col :cols="mobile ? '8' : '9'">
                <span class="text-h5">Facilities</span>
              </v-col>
              <v-col>
                <v-row class="justify-end">
                  <v-btn
                    small
                    color="grey"
                    class="back-button"
                    @click="setShow('form')"
                    >Back</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mb-1" />

          <v-card-text class="pb-2">
            <div class="mb-3">
              <h4>Available Facilites</h4>
              <v-row v-if="availFacilities && availFacilities.length">
                <v-col
                  v-for="(facility, index) in availFacilities"
                  :key="index"
                >
                  <FacilityInfo
                    ref="FacilityInfo"
                    :facility="formatFacility(facility)"
                    :facilityName="facilityName(facility)"
                    :type="'avail'"
                    @handleSelect="handleSelect($event)"
                  />
                </v-col>
              </v-row>
              <v-alert
                :icon="false"
                color="red"
                dense
                outlined
                v-else
                class="text-center m-4 w-100"
                style="margin-top:1rem;"
                >No Facilites Are Available For The Dates/Times That Have Been
                Selected</v-alert
              >
            </div>
            <div
              class="mb-3 "
              v-if="unAvailFacilities && unAvailFacilities.length"
            >
              <h4>Unavailable Facilites</h4>
              <v-row class="w-100">
                <v-col
                  v-for="(facility, index) in unAvailFacilities"
                  :key="index"
                >
                  <FacilityInfo
                    ref="FacilityInfo"
                    :facility="formatFacility(facility)"
                    :facilityName="facilityName(facility)"
                    :type="'unavail'"
                    @handleSelect="handleSelect($event)"
                  />
                </v-col>
              </v-row>
            </div>
            <div v-if="availFacilities && availFacilities.length">
              <small class="mt-4"
                >Select a facility that you would like to book. If the facility
                you require is not available please try searching alternative
                dates or times.
              </small>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-alert
            v-if="validateForm"
            class="text-center mb-0"
            color="red"
            type="error"
            dense
            outlined
            dark
            >Please Complete All Required Fields</v-alert
          >
        </v-card>
        <v-card class="m-2 p-2" v-if="show === 'cal'">
          <v-card-title class="justify-content-center bg-tfsc">
            <v-row>
              <v-col :cols="mobile ? '8' : '9'">
                {{ facilityName(selectedFacility) }}
              </v-col>

              <v-col>
                <v-row class="justify-end">
                  <v-btn
                    small
                    color="grey"
                    class="back-button"
                    @click="setShow('fac-list')"
                    >Back</v-btn
                  >
                </v-row>
              </v-col>
            </v-row></v-card-title
          >
          <hr />
          <p class="text-center bespoke-margin">
            <!-- View Time Slots Available For This Facility, If You Would Like To Ammnd The Date/Time<br/> Please Return Using The <b>Back</b> Button Alternativley Select <b>Make Booking</b> To Proceed. -->
            View time slots available for this facility, if you would like to amend the date/time of this <br/>booking request please do so using the <b>Back</b> button, alternatively select <b>Make Booking</b> to proceed.
          </p>
          <v-row class="pb-5" justify="center">
            <v-btn 
              color="green"
              class="back-button"
              @click="slotClicked()">Make Booking
            </v-btn>
          </v-row>
          <SlotsCalendar
            class="p-3"
            key="1"
            :facilities="facilities"
            :slots="slots"
            :mobile="mobile"
            :makeABooking="true"
            :searchDate="date"
            :duration="duration"
            :facilitySport="sport"
            :status="'Booked'"
            @setShowMakeBooking="setShowMakeBooking($event)"
            @slotClicked="slotClicked($event)"
          />
        </v-card>
        <TimeSlot
          v-if="
            show === 'slot' ||
              show === 'cust-info' ||
              show === 'pay' ||
              show === 'paying'
          "
          :query="query"
          :show="show"
          :showMakeABooking="showMakeABooking"
          @setShowMakeBooking="setShowMakeBooking"
          @setShow="setShow($event)"
        />
      </v-card>
    </v-row>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import moment from "moment";
import FacilityInfo from "../../components/Modals/FacilityInfo";
import SlotsCalendar from "../../components/Calendar";
import Slot from "../../components/Slot.vue";
import {
  fetchPageContent,
  checkAvailability,
  fetchFacilities,
  getSlotsById
} from "../../services/FacilityService";
export default {
  name: "Landing",
  components: {
    VueTimepicker,
    SlotsCalendar,
    TimeSlot: Slot,
    FacilityInfo
  },
  data: () => ({
    dialog: false,
    activePicker: null,
    selectedFacility: {},
    showMakeABooking: false,
    unAvailFacilities: [],
    date: "",
    sport: "",
    pageLoading: true,
    pageContent: null,
    query: null,
    startTime: "",
    endTime: "",
    slots: [],
    facilities: [],
    facilityOptions: [],
    facility: null,
    searchFacilities: [],
    sportOptions: [],
    mobile: window.innerWidth <= 1200,
    availFacilities: [],
    menu: false,
    validateForm: false,
    validateDates: false,
    show: "form",
    hourRange: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
  }),
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1200;
    });
  },
  computed: {
    hourRangeEnd() {
      let arr = [];
      let tmpStartTime = this.startTime.slice(0, 2);
      for (let i = Number(tmpStartTime); i < 24; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("dddd, MMMM Do YYYY") : "";
    },
    duration() {
      let start_hour_date = moment([`${this.startTime}, 00`], "HH:mm:ss");
      let end_hour_date = moment([`${this.endTime}, 00`], "HH:mm:ss");
      let total_minutes = end_hour_date.diff(start_hour_date, "minutes");
      return total_minutes.toString();
    },
    formatToday() {
      return moment(new Date()).format("YYYY-MM-DD");
    }
  },
  async mounted() {
    await this.getPageContent();
    await this.getFacilites();
    this.getSlots(this.facility);
  },
  methods: {
    async calcUnAvailFacilities(availFacilities) {
      let spreadSearchAvilable = [...this.searchFacilities];
      let indexToRemove = [];
      if (
        this.searchFacilities &&
        this.availFacilities &&
        this.availFacilities.length
      ) {
        // Loop through to get list of indexs to remove from spreadSearchAvilable
        for await (const item of this.searchFacilities) {
          let itemIndex = availFacilities.findIndex(
            b => b.facilityId === item.facilityId
          );
          indexToRemove.push(itemIndex);
        }
        let count = 0;
        // Loop through index's and remove with array that keeps track of updated index to remove
        for await (const [index, removeIdx] of indexToRemove.entries()) {
          spreadSearchAvilable.splice(
            index === 0 ? removeIdx : removeIdx - count,
            1
          );
          count++;
        }
        this.unAvailFacilities = spreadSearchAvilable;
      } else if (
        this.searchFacilities &&
        this.availFacilities &&
        !this.availFacilities.length
      ) {
        this.unAvailFacilities = this.searchFacilities;
      } else {
        this.unAvailFacilities = [];
      }
    },
    slotClicked() {
      let query = {
        id: this.availFacilities.filter((fclty)=> fclty.facilityId === this.selectedFacility.productId)[0]._id
      };
      if (this.duration) {
        query.duration = this.duration;
      }
      if (this.facilitySport) {
        query.facilitySport = this.facilitySport;
      }
      if (this.status) {
        query.status = this.status;
      }

      this.setShowMakeBooking(false)

      this.query = query;
      this.show = "slot";
    },
    async getFacilites() {
      let res = await fetchFacilities();
      this.isBusy = false;
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }
      this.facilities = [...res.data];
      this.facilityOptions = res.data.map(facility => {
        return { text: facility.title, value: facility.facilityId };
      });
      let arr = [];
      // Set Sport Options for Dropdwon
      for (const facility of this.facilities) {
        arr = arr.concat(facility.facilitySportOptions);
      }
      this.sportOptions = [...new Set(arr)];
      this.facility = this.facilityOptions[0].value;
    },
    async getPageContent() {
      this.pageLoading = true;
      let res = await fetchPageContent();
      this.isBusy = false;
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
        this.pageLoading = false;
      }
      this.pageContent = res.data[0];
      this.pageLoading = false;
    },
    facilityName(facility) {
      facility = facility ? facility : { facilityId: this.facility };
      return this.searchFacilities.filter(
        fac => facility.facilityId === fac.facilityId
      )[0].title;
    },
    async getSlots(facility) {
      let res = await getSlotsById(facility);
      this.isBusy = false;
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }

      this.slots = res.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      this.total_rows = res.length;
    },
    updateSport() {
      this.searchFacilities = [...this.facilities].filter(facility => {
        if (facility.facilitySportOptions.includes(this.sport)) {
          return facility;
        }
      });
    },
    searchFacilityIds() {
      return [...this.searchFacilities].map(item => {
        if (item && item.facilityId) return item.facilityId;
        return "";
      });
    },
    async checkAvailability() {
      this.availFacilities = [];
      this.validateForm = false;
      this.validateDates = false;
      if (
        Number(this.startTime.replace(":", "")) >=
          Number(this.endTime.replace(":", "")) ||
        Number(this.endTime.replace(":", "")) -
          Number(this.startTime.replace(":", "")) <
          60
      ) {
        this.validateDates = true;
        setTimeout(() => {
          this.validateDates = false;
        }, 6000);
      } else if (
        this.date !== "" &&
        this.startTime !== "" &&
        this.startTime !== "" &&
        this.endTime !== "" &&
        this.sport !== ""
      ) {
        const data = {
          facilityIds: this.searchFacilityIds(),
          searchStart: `${this.date} ${this.startTime}`,
          searchEnd: `${this.date} ${this.endTime}`
        };
        let res = await checkAvailability(data);
        if (res.error) {
          this.text = "An internal server error occurred. Please try later.";
        }
        this.availFacilities = res.data;
        this.show = "fac-list";
        this.calcUnAvailFacilities(res.data);
        // this.show = "form";
        // this.show = "cal";
      } else {
        this.validateForm = true;
        setTimeout(() => {
          this.validateForm = false;
        }, 6000);
      }
    },
    handleSelect(facility) {
      this.selectedFacility = facility;
      this.getSlots(facility.facilityId);
      this.show = "cal";
    },
    resetFields() {
      this.dialog = false;
      this.date = "";
      this.sport = "";
      this.startTime = "";
      this.endTime = "";
    },
    setShow(type) {
      this.show = type;
    },
    setShowMakeBooking(type) {
      if (type) {
        this.showMakeABooking = type;
      } else {
        this.showMakeABooking = !this.showMakeABooking;
      }
      this.show = "form";
    },
    formatFacility(facility) {
      return this.facilities.filter(
        availFac => availFac.facilityId === facility.facilityId
      )[0];
    }
  }
};
</script>
<style>
.bg-tfsc {
  background-color: #c4e6e1;
}

.back-button {
  margin: 14px;
}
.v-dialog {
  z-index: -1;
}
</style>
